// extracted by mini-css-extract-plugin
export default {"root":"DiagnosticPackageTableHead_root__lhDwi","status":"DiagnosticPackageTableHead_status__7sU3g"};